import React from 'react';
import PropTypes from 'prop-types';
import {SortableContext as SortableContextBase, verticalListSortingStrategy} from '@dnd-kit/sortable';

const SortableContext = React.forwardRef((props, ref) => {
  const {
    children,
    ...rest
  } = {
    strategy: verticalListSortingStrategy,
    ...props
  };

  return <SortableContextBase ref={ref} {...rest}>
    {children}
  </SortableContextBase>
});

SortableContext.propTypes = {
  placeholder: PropTypes.any,
  timeout: PropTypes.number,
  strategy: PropTypes.any
};

export default SortableContext;
